import { styled } from '@mui/material';

export const CustomBadge = styled('span')<{ $header?: boolean }>(({ theme, $header }) => ({
  backgroundColor: theme.palette.error.main,
  color: theme.palette.common.white,
  borderRadius: '4px',
  padding: '1px 6px',
  fontSize: '11px',
  fontWeight: 700,
  marginLeft: $header ? '10px' : '8px',
  verticalAlign: 'middle',
  display: 'inline-block',
  lineHeight: 'initial',
}));
